import React, { memo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography,
    Divider,
    TextField,
    Autocomplete,
    FormControl,
    FormHelperText,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Stack,
    Button,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import AmountBreakdownGrid from "./AmountBreakdownGrid";
import OrderItemsTable from "./OrderItemsTable";
import useDefaultParameterConfigById from "../../../hooks/useDefaultParameterConfigById";


function SectionCard({ title, subtitle, children }) {
    return (
        <Card sx={{ bgcolor: "transparent", borderRadius: 1, mb: 1, mt: 1, mr: 1 }}>
            <Box sx={{ display: "flex", p: 1, justifyContent: "space-between", alignItems: "center", color: "text.primary" }}>
                <Typography variant="h5">{title}</Typography>
                {subtitle ? (
                    <Typography ml={1} variant="h6" fontWeight="bold" fontSize={13}>
                        {subtitle}
                    </Typography>
                ) : null}
            </Box>
            <Divider />
            <CardContent sx={{ p: 1.25 }}>{children}</CardContent>
        </Card>
    );
}

SectionCard.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.node,
    children: PropTypes.node,
};

const dpTextField = { textField: { size: "small", margin: "dense", variant: "standard", fullWidth: true } };

const InvoiceEntryTemplate = (props) => {
    const {
        colors,
        theme,

        IParentInvoiceOrder_ID,
        SInvoiceNo,

        selectedCustomer,
        dataCustomer,
        handleSelectCustomer,

        OrderDate,
        minInvoiceDate,
        handlerOrderDate,

        selectedSupplier,
        dataSupplier,
        handleSelectSupplier,

        SRefNo,

        selectedTransporter,
        dataTransporter,
        handleSelectTransporter,

        ScheduleDate,
        handleScheduleDate,

        selectedPricelist,
        dataPricelist,
        handleSelectPricelist,

        Remarks,
        SetRemarks,

        visibleAmendmentReason,
        SAmendmentReason,
        handleSelectAmendmentReason,
        amendmentReasonFoucs,

        viewCancelDetail,
        Reason,
        handleEnterReason,
        ReasonError,
        cancelDate,
        handleDateChange,
        DateError,

        rowsConfirmedOrdersDespacth = [],
        // columnsConfirmedOrdersDespacth = [],
        rowModesModel,
        handleRowModesModelChange,
        handleRowEditStop,
        processRowUpdate,
        setrowsConfirmedOrdersDespacth,
        setRowModesModel,
        EditToolbar,

        totalSIConfirmedQty,
        totalGrossAmount,
        totaldiscountAmount,
        totalAmount,

        billToCustomerError,
        shipToCustomerError,
        transporterError,
        priceListError,

        selectedShipmentMode,
        handleSelectShipmentMode,
        dataShipmentmode,

        selectedPaymentTerm,
        handleSelectPaymentTerm,
        dataPaymentterm,

        selectedCreditTerm,
        handleSelectCreditTerm,
        dataCreditterm,

        selectedCreditTermRule,
        handleSelectCreditTermRule,
        dataCredittermRule,

        cancelReasonFoucs,
        truckNumber,
        lrNumber,
        lrDate,
        distance,
        setDistance,
        headerData,
        defaultParameterConfig,
        totals,
        handleSaveJsonFile,
        manualTCSRate,
        setManualTCSRate,
        manualFreightRate,
        setManualFreightRate,
        manualServiceChargeRate,
        setManualServiceChargeRate,
        manualCessRate,
        setManualCessRate,
        manualInsuranceRate,
        setManualInsuranceRate,
        onChangeFreightPerMt,
        onChangeServiceCharge,
        onChangeCessRate,
        onChangeTcsRate,
        onChangInsuranceCharge,
        manualTCSRateEdit,
        onRowValueChange,
    } = props;



const invoiceDate = OrderDate ? dayjs(OrderDate) : null;
const minInvDate = minInvoiceDate ? dayjs(minInvoiceDate) : undefined;
const scheduleDate = ScheduleDate ? dayjs(ScheduleDate) : null;
const cancelDay = cancelDate ? dayjs(cancelDate) : null;

// const [bTCSApplicable, setBTCSApplicabel] = useState(false);
// const [mTCSRate, setMTCSRate] = useState(0);
// const [mTCSThresoldAmount, setMTCSThresoldAmount] = useState(0);
// const [bManualTCSCalculation, setBManualTCSCalculationt] = useState(0);
// const [bPartyTCSControlledByFlag, setBPartyTCSControlledByFlag] = useState(0);



// Input data from your React state or props
const supplierAddr = [
    { LabelName: "State", LabelValue: "Maharashtra" },
];

const billToAddr = [
    { LabelName: "State", LabelValue: "Gujarat" },
];

const itemList = [
    {
        SIOrderType: "Domestic",
        SIUnitPrice: 120,
        SIRequested_Qty: 10,
        SIConfirmed_Qty: 0,
        SIPlanned_Qty: 0,
        SIShipped_Qty: 0,
        SIDiscount: 5,
        SIDiscountType: "Rate",
        SICGSTPercent: 9,
        SISGSTPercent: 9,
        SIIGSTPercent: 18,
        SIUnit: "kg",
    },
];






// const [totals, setTotals] = useState({
//     TotalQty: 0,
//     totalAmountExclDiscount: 0,
//     totalDiscount: 0,
//     totalAmountAfterDiscount: 0,
//     freightAmount: 0,
//     insuranceAmount: 0,
//     serviceChargeAmount: 0,
//     totalTaxableAmount: 0,
//     totalGSTAmount: 0,
//     totalCessAmount: 0,
//     roundOff: 0,
//     tcsAmount: 0,
//     netAmountWithRounding: 0,
//     salesAmount: 0,
// });




// const calculateTotal = () => {

//     let totalQty = 0;
//     let totalAmountExclDiscount = 0;
//     let totalAmountAfterDiscount = 0;
//     let totalDiscount = 0;
//     let totalTaxAmount = 0;

//     let cessRate = headerData.CessRate;
//     let freightRate = headerData.FreightPerMT;
//     let insuranceRate = headerData.InsuranceRate;
//     let serviceChargeRate = headerData.ServiceChargeRate;

//     const originState = supplierAddr.find(
//         (x) => x.LabelName?.toLowerCase() === "state"
//     )?.LabelValue?.toLowerCase();

//     const destinationState = billToAddr.find(
//         (x) => x.LabelName?.toLowerCase() === "state"
//     )?.LabelValue?.toLowerCase();

//     const isInterState = originState !== destinationState;
//     const taxBreakdown = [];

//     let isExportOrder = false;
//     let isDomesticOrder = false;

//     const round2 = (num) =>
//         Number(Number(num).toFixed(2));

//     const rows = rowsConfirmedOrdersDespacth.map((row) => {

//         let lineQty = row.SIRequested_Qty || 0;
//         if (row.SIConfirmed_Qty > 0) lineQty = row.SIConfirmed_Qty;
//         if (row.SIPlanned_Qty > 0) lineQty = row.SIPlanned_Qty;
//         if (row.SIShipped_Qty > 0) lineQty = row.SIShipped_Qty;

//         const lineUnitPrice = row.SIUnitPrice || 0;
//         const discountValue = row.SIDiscount || 0;
//         const discountType = row.SIDiscountType?.toLowerCase();
//         let discountedUnitPrice = lineUnitPrice;
//         let lineDiscountAmt = 0;

//         if (discountValue > 0) {
//             if (discountType === "rate") {
//                 discountedUnitPrice = lineUnitPrice - (lineUnitPrice * discountValue) / 100;
//                 lineDiscountAmt = lineQty * ((lineUnitPrice * discountValue) / 100);
//             } else {
//                 discountedUnitPrice = lineUnitPrice - discountValue;
//                 lineDiscountAmt = lineQty * discountValue;
//             }
//         }

//         const lineAmount = round2(lineQty * lineUnitPrice);
//         lineDiscountAmt = round2(lineDiscountAmt);
//         const afterDiscount = round2(lineAmount - lineDiscountAmt);

//         // Convert quantity to kg
//         if (row.SIUnit?.toLowerCase() === "ton") lineQty *= 1000;

//         const insuranceAmt = round2((afterDiscount * insuranceRate) / 100);
//         const freightAmt = round2((lineQty / 1000) * freightRate);
//         const serviceChargeAmt = round2((afterDiscount * serviceChargeRate) / 100);

//         const taxableValue = round2(afterDiscount + insuranceAmt + serviceChargeAmt);

//         let cgstAmt = 0, sgstAmt = 0, igstAmt = 0;

//         if (isInterState) {
//             if (row.SIIGSTPercent > 0) {
//                 igstAmt = round2((taxableValue * row.SIIGSTPercent) / 100);
//                 taxBreakdown.push({
//                     TaxCategory: "IGST Tax",
//                     TaxPercent: row.SIIGSTPercent,
//                     TaxableAmount: taxableValue,
//                     TaxAmount: igstAmt,
//                 });
//             }
//         } else {
//             if (row.SICGSTPercent > 0) {
//                 cgstAmt = round2((taxableValue * row.SICGSTPercent) / 100);
//                 taxBreakdown.push({
//                     TaxCategory: "CGST Tax",
//                     TaxPercent: row.SICGSTPercent,
//                     TaxableAmount: taxableValue,
//                     TaxAmount: cgstAmt,
//                 });
//             }
//             if (row.SISGSTPercent > 0) {
//                 sgstAmt = round2((taxableValue * row.SISGSTPercent) / 100);
//                 taxBreakdown.push({
//                     TaxCategory: "SGST Tax",
//                     TaxPercent: row.SISGSTPercent,
//                     TaxableAmount: taxableValue,
//                     TaxAmount: sgstAmt,
//                 });
//             }
//         }

//         const lineTaxAmount = isInterState ? igstAmt : cgstAmt + sgstAmt;
//         const cessAmt = round2((lineTaxAmount * cessRate) / 100);

//         const totalLineAmount = round2(
//             afterDiscount + insuranceAmt + serviceChargeAmt + cessAmt + lineTaxAmount
//         );

//         totalQty += lineQty;
//         totalAmountExclDiscount += lineAmount;
//         totalTaxAmount += lineTaxAmount;
//         totalDiscount += lineDiscountAmt;
//         totalAmountAfterDiscount += afterDiscount;



//         return {
//             ...row,
//             SILineTaxableAmount: taxableValue,
//             SIDiscountAmount: lineDiscountAmt,
//             SICGSTAmount: cgstAmt,
//             SISGSTAmount: sgstAmt,
//             SIIGSTAmount: igstAmt,
//             SICessAmount: cessAmt,
//             SIFreightAmount: freightAmt,
//             SIInsuranceAmount: insuranceAmt,
//             SIServiceChargeAmount: serviceChargeAmt,
//             SIBeforeDiscountAmount: lineAmount,
//             SIAfterDiscountAmount: afterDiscount,
//             SILineTaxAmount: totalLineAmount,
//         };
//     });

//     const freightAmount = round2((totalQty / 1000) * freightRate);

//     const insuranceAmount = round2(
//         ((freightAmount + totalAmountAfterDiscount) * insuranceRate) / 100
//     );

//     const serviceChargeAmount = round2(
//         (totalAmountAfterDiscount * serviceChargeRate) / 100
//     );

//     const totalTaxableAmount = round2(
//         totalAmountAfterDiscount + insuranceAmount + freightAmount + serviceChargeAmount
//     );


//     // ---- GST SUMMARY ----
//     let cgstRate = 0,
//         sgstRate = 0,
//         igstRate = 0;
//     let cgstAmount = 0,
//         sgstAmount = 0,
//         igstAmount = 0;

//     if (!isExportOrder) {
//         if (isInterState) {

//             igstRate = rowsConfirmedOrdersDespacth[0]?.SIIGSTPercent || 0;
//             igstAmount = round2((totalTaxableAmount * igstRate) / 100);
//             taxBreakdown.push({
//                 TaxCategory: "IGST Tax",
//                 TaxPercent: igstRate,
//                 TaxableAmount: totalTaxableAmount,
//                 TaxAmount: igstAmount,
//             });
//         } else {
//             cgstRate = rowsConfirmedOrdersDespacth[0]?.SICGSTPercent || 0;
//             sgstRate = rowsConfirmedOrdersDespacth[0]?.SISGSTPercent || 0;
//             cgstAmount = round2((totalTaxableAmount * cgstRate) / 100);
//             sgstAmount = round2((totalTaxableAmount * sgstRate) / 100);
//             taxBreakdown.push(
//                 {
//                     TaxCategory: "CGST Tax",
//                     TaxPercent: cgstRate,
//                     TaxableAmount: totalTaxableAmount,
//                     TaxAmount: cgstAmount,
//                 },
//                 {
//                     TaxCategory: "SGST Tax",
//                     TaxPercent: sgstRate,
//                     TaxableAmount: totalTaxableAmount,
//                     TaxAmount: sgstAmount,
//                 }
//             );
//         }
//     }

//     const totalGSTAmount = round2(igstAmount + cgstAmount + sgstAmount);

//     // ---- CESS ----
//     const totalCessAmount = round2((totalGSTAmount * cessRate) / 100);

//     // ---- NET AMOUNTS ----
//     let netAmountWithoutRounding = round2(
//         totalAmountAfterDiscount +
//         insuranceAmount +
//         freightAmount +
//         serviceChargeAmount +
//         totalCessAmount +
//         totalGSTAmount
//     );

//     let netAmountWithRounding = Math.round(netAmountWithoutRounding);
//     const roundOff = round2(netAmountWithRounding - netAmountWithoutRounding);
//     let salesAmount = netAmountWithRounding;

//     // ---- TCS ----
//     let tcsAmount = 0;

//     let bTCSApplicable = false;
//     let mTCSRate = 0;
//     let mTCSThresoldAmount = 0;
//     let bManualTCSCalculation = true;
//     let bPartyTCSControlledByFlag = true;
//     let tcsRate = 0;
//     let bPartyTCSApplicable = false;
//     let mCurrentSaleValue = headerData.CurrentSaleValue;
//     let mOrderStatus = 'Invoiced';

//     if (defaultParameterConfig[0].p_default_value_code === '1') {
//         bTCSApplicable = true;
//         mTCSRate = parseFloat(defaultParameterConfig[0].p_minvalue);
//         mTCSThresoldAmount = parseFloat(defaultParameterConfig[0].p_maxvalue);
//         bManualTCSCalculation = parseFloat(defaultParameterConfig[0].p_enableui);
//         bPartyTCSControlledByFlag = (defaultParameterConfig[0].p_default_value);
//     }



//     // if (bTCSApplicable) {
//     //     let tcsOnValue = netAmountWithRounding;
//     //     if (bManualTCSCalculation){
//     //         mTCSAmount=Math.round(tcsOnValue *mTCSRate)/100,0
//     //     }
//     // }

//     // ----------------- TCS (complete) -----------------
//     /*
//       Assumptions:
//       - `tcsRate` holds the UI-supplied TCS rate (like your oTCSRate in VB). If not, it will default to 0.
//       - The default-parameter values you parsed earlier are:
//           bTCSApplicable, mTCSRate, mTCSThresoldAmount, bManualTCSCalculation, bPartyTCSControlledByFlag
//       - mCurrentSaleValue, mOrderStatus and bPartyTCSApplicable exist in scope (provide them from parent state if needed).
//     */
//     const oTCSRate = Number(tcsRate || 0);          // UI supplied TCS rate (oTCSRate)
//     const manualTCS = !!bManualTCSCalculation;      // boolean
//     const partyControlFlag = !!bPartyTCSControlledByFlag; // boolean
//     const partyTCSApplicable = !!bPartyTCSApplicable;     // boolean (fallback false if undefined)
//     const currentSale = Number(mCurrentSaleValue || 0);
//     const orderStatus = (mOrderStatus || "").toString();

//     let mTCSAmount = 0; // VB's mTCSAmount

//     if (Boolean(bTCSApplicable)) {
//         // default TCS base = rounded net amount (netAmountWithRounding computed earlier)
//         let TCSOnValue = netAmountWithRounding;

//         if (manualTCS) {
//             // Total manual control: use UI-entered rate (oTCSRate)
//             mTCSAmount = Math.round((TCSOnValue * oTCSRate) / 100); // rounded to 0 decimals
//         } else if (partyControlFlag) {
//             // Controlled by Party Master: use mTCSRate if party is applicable, otherwise tmp rate = 0
//             if (partyTCSApplicable) {
//                 // show rate mTCSRate in UI (if you want to set a textbox/state)
//                 // e.g. setTcsRateDisplay(Number(mTCSRate).toFixed(2))
//                 mTCSAmount = Math.round((TCSOnValue * Number(mTCSRate || 0)) / 100);
//             } else {
//                 const tmpTCSRate = 0;
//                 // setTcsRateDisplay(tmpTCSRate.toFixed(2))
//                 mTCSAmount = Math.round((TCSOnValue * tmpTCSRate) / 100);
//             }
//         } else {
//             // Auto TCS Calculation — based on cumulative sales threshold
//             let CurrentTotalSaleValue = currentSale + totalTaxableAmount; // totalTaxableAmount computed earlier
//             mTCSAmount = 0;

//             // Only calculate if CurrentTotalSaleValue > threshold and order not already Invoiced
//             if (CurrentTotalSaleValue > Number(mTCSThresoldAmount || 0) &&
//                 orderStatus.toLowerCase() !== "invoiced") {

//                 if (currentSale < Number(mTCSThresoldAmount || 0)) {
//                     // Consider only the portion above threshold
//                     TCSOnValue = currentSale + netAmountWithRounding - Number(mTCSThresoldAmount || 0);
//                 }

//                 // show rate mTCSRate in UI: setTcsRateDisplay(Number(mTCSRate).toFixed(2))
//                 mTCSAmount = Math.round((TCSOnValue * Number(mTCSRate || 0)) / 100);
//             }
//         }
//     }

//     // expose TCS results in variables used later
//     tcsAmount = Number(mTCSAmount || 0);

//     // add TCS to net amount (same behavior as VB: add mTCSAmount after rounding)
//     netAmountWithRounding = Number(netAmountWithRounding || 0) + tcsAmount;

//     // If you maintain UI fields (Txb_TCSRate/Textboxes), set them here via state setters:
//     // e.g. setTcsRateDisplay( (manualTCS ? oTCSRate : mTCSRate).toFixed(2) )
//     // e.g. setTcsAmountDisplay(tcsAmount.toFixed(2))
//     //
//     // Also include tcsAmount in the totalSummary later:
//     // totalSummary.push({ label: "TCS Amount", value: tcsAmount });





//     const totalSummary = {
//         TotalQty: totalQty,
//         totalAmountExclDiscount: totalAmountExclDiscount,
//         totalDiscount: totalDiscount,
//         totalAmountAfterDiscount: totalAmountAfterDiscount,
//         freightAmount: freightAmount,
//         insuranceAmount: insuranceAmount,
//         serviceChargeAmount: serviceChargeAmount,
//         totalTaxableAmount: totalTaxableAmount,
//         totalGSTAmount: totalGSTAmount,
//         totalCessAmount: totalCessAmount,
//         roundOff: roundOff,
//         tcsAmount: tcsAmount,
//         netAmountWithRounding: netAmountWithRounding,
//         salesAmount: salesAmount,

//     };

//     setTotals(totalSummary);


// }

// const [isDataLoad, setIsDataLoad] = useState(false);
// useEffect(() => {
//     if (!isDataLoad) {
//         calculateTotal();
//         setIsDataLoad(true);
//     }

// })




return (
    <ResponsiveBox
        colors={colors}
        customMaxHeight={{ xs: "72vh", sm: "72vh", md: "74vh", lg: "74vh", xl: "82vh" }}
    >

        <Box sx={{ p: 1 }}>
            <Stack direction="row" spacing={1} sx={{ flexWrap: "nowrap", overflowX: "auto", pb: 1 }}>

                {/* Order Header */}
                <Box sx={{ flex: "0 0 30%", minWidth: 360 }}>
                    <SectionCard title="Order Header" subtitle={<>
                        ( Invoice Plan No : <span style={{ fontStyle: "normal" }}>{IParentInvoiceOrder_ID}</span> )
                    </>
                    }>
                        <Grid container spacing={1}>

                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth variant="standard" label="Invoice No" value={SInvoiceNo || ""} InputProps={{ readOnly: true }} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker label="Invoice date" disabled value={invoiceDate} minDate={minInvDate} onChange={handlerOrderDate} slotProps={dpTextField} />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth variant="standard" label="Party PO No" value={SRefNo || ""} disabled />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker disabled label="Schedule date" value={scheduleDate} onChange={handleScheduleDate} slotProps={dpTextField} />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth label="Remarks" variant="standard" value={Remarks || ""} onChange={(e) => SetRemarks(e.target.value)} />
                            </Grid>

                            <Grid item xs={12}>
                                {visibleAmendmentReason ? (
                                    <TextField fullWidth label="Amendment Reason" required error={!!props.amendReasonError} helperText={props.amendReasonError} autoFocus={amendmentReasonFoucs} value={SAmendmentReason || ""}
                                        onChange={handleSelectAmendmentReason} variant="standard" />
                                ) : null}
                            </Grid>
                        </Grid>
                    </SectionCard>
                </Box>

                {/* Order Details (Order Party tab simulated) */}
                <Box sx={{ flex: "0 0 40%", minWidth: 520 }}>
                    <SectionCard title="Order Details">
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6}>

                                <Autocomplete fullWidth size="small" disabled value={selectedCustomer || null} onChange={handleSelectCustomer}
                                    options={dataCustomer || []} getOptionLabel={(o) => o?.Description || ""} isOptionEqualToValue={(o, v) => o?.CodeId === v?.CodeId}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" required error={!!billToCustomerError} helperText={billToCustomerError} label="Bill-To Party" margin="dense" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>

                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    disabled
                                    value={selectedSupplier || null}
                                    onChange={handleSelectSupplier}
                                    options={dataSupplier || []}
                                    getOptionLabel={(o) => o?.Description || ""}
                                    isOptionEqualToValue={(o, v) => o?.CodeId === v?.CodeId}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" required error={!!shipToCustomerError} helperText={shipToCustomerError} label="Ship-To Party" margin="dense" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>

                                <Autocomplete
                                    fullWidth size="small" disabled
                                    value={selectedTransporter || null} onChange={handleSelectTransporter} options={dataTransporter || []}
                                    getOptionLabel={(o) => o?.Description || ""} isOptionEqualToValue={(o, v) => o?.CodeId === v?.CodeId}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Transporter" required error={!!transporterError} helperText={transporterError} variant="standard" margin="dense" />
                                    )}
                                />

                            </Grid>
                            <Grid item xs={12} sm={6}>

                                <Autocomplete
                                    disabled
                                    size="small"
                                    fullWidth
                                    value={selectedShipmentMode || null}
                                    onChange={handleSelectShipmentMode}
                                    options={dataShipmentmode || []}
                                    getOptionLabel={(o) => o?.Description || ""}
                                    isOptionEqualToValue={(o, v) => o?.CodeId === v?.CodeId}
                                    renderInput={(params) => <TextField {...params} label="Shipment Mode" variant="standard" margin="dense" />}
                                />
                            </Grid>

                            <Grid item xs={6} sm={3}>
                                <TextField size="small" variant="standard" label="Truck Number" value={truckNumber} fullWidth />
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <TextField size="small" variant="standard" label="LR Number" value={lrNumber} fullWidth />
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker label="LR Date" disabled value={dayjs("2025-04-25")} slotProps={dpTextField} />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <TextField size="small" variant="standard" label="Distance (Km)" value={distance} onChange={(e) => { setDistance(e.target.value) }} fullWidth />
                            </Grid>
                        </Grid>
                    </SectionCard>
                </Box>

                {/* Additional Details (Order Party tab simulated) */}
                <Box sx={{ flex: "0 0 28%", minWidth: 300 }}>
                    <SectionCard title="Order Details">
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6}>
                                <Autocomplete
                                    disabled
                                    size="small"
                                    fullWidth
                                    value={selectedPaymentTerm || null}
                                    onChange={handleSelectPaymentTerm}
                                    options={dataPaymentterm || []}
                                    getOptionLabel={(o) => o?.Description || ""}
                                    isOptionEqualToValue={(o, v) => o?.CodeId === v?.CodeId}
                                    renderInput={(params) => <TextField {...params} label="Payment Term" variant="standard" margin="dense" />}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Autocomplete
                                    disabled
                                    size="small"
                                    fullWidth
                                    value={selectedCreditTerm || null}
                                    onChange={handleSelectCreditTerm}
                                    options={dataCreditterm || []}
                                    getOptionLabel={(o) => o?.Description || ""}
                                    isOptionEqualToValue={(o, v) => o?.CodeId === v?.CodeId}
                                    renderInput={(params) => <TextField {...params} label="Credit Term" variant="standard" margin="dense" />}
                                />

                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Autocomplete
                                    disabled
                                    size="small"
                                    fullWidth
                                    value={selectedCreditTermRule || null}
                                    onChange={handleSelectCreditTermRule}
                                    options={dataCredittermRule || []}
                                    getOptionLabel={(o) => o?.Description || ""}
                                    isOptionEqualToValue={(o, v) => o?.CodeId === v?.CodeId}
                                    renderInput={(params) => <TextField {...params} label="Credit Term Rule" variant="standard" margin="dense" />}
                                />

                            </Grid>

                            {viewCancelDetail ? (
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Cancel Reason"
                                            variant="standard"
                                            value={Reason || ""}
                                            onChange={handleEnterReason}
                                            error={!!ReasonError}
                                            helperText={ReasonError}
                                            autoFocus={cancelReasonFoucs}
                                            required
                                        />
                                    </Grid>

                                    <Grid item xs={6} sm={6}>
                                        <FormControl fullWidth required error={!!DateError}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker label="Cancel Date" value={cancelDay} onChange={handleDateChange} slotProps={dpTextField} />
                                            </LocalizationProvider>
                                            {DateError ? <FormHelperText error>{DateError}</FormHelperText> : null}
                                        </FormControl>
                                    </Grid>

                                </>) : (null)}

                        </Grid>
                    </SectionCard>
                </Box>

            </Stack>
        </Box>

        <Box m="8px">
            <OrderItemsTable rows={rowsConfirmedOrdersDespacth} setrowsConfirmedOrdersDespacth={setrowsConfirmedOrdersDespacth} onRowValueChange={onRowValueChange}/>
        </Box>



        <Box m="8px" mt={2}>
            <AmountBreakdownGrid
                currency="₹"
                totalQtyKg={totals.TotalQty}
                grossAmount={totals.totalAmountExclDiscount}
                discountAmount={totals.totalDiscount}
                totalAmount={totals.totalAmountAfterDiscount}
                // Pass additional values from state/props or keep defaults:   freightPerMt={headerData.FreightPerMT}setManualFreightRate(v);
                freightPerMt={headerData.FreightPerMT}
                freightAmount={totals.freightAmount}
                insuranceRatePct={headerData.insuranceRatePct}
                insuranceAmount={totals.insuranceAmount}
                serviceChargePct={headerData.ServiceChargeRate}
                serviceChargeAmount={totals.serviceChargeAmount}
                taxableAmount={totals.totalTaxableAmount}
                taxAmount={totals.totalGSTAmount}
                cessRatePct={headerData.CessRate}
                cessAmount={totals.totalCessAmount}
                roundOff={totals.roundOff}
                saleAmount={totals.salesAmount}
                tcsRatePct={headerData.Tcsrate}
                tcsAmount={totals.tcsAmount}
                netAmount={totals.netAmountWithRounding}
                onChangeFreightPerMt={(v) => { onChangeFreightPerMt(v); }}
                onChangeServiceCharge={(v) => { onChangeServiceCharge(v); }}
                onChangeCessRate={(v) => { onChangeCessRate(v); }}
                onChangeTcsRate={(v) => { onChangeTcsRate(v); }}
                onChangInsuranceCharge={(v)=>{onChangInsuranceCharge(v);}}
                manualTCSRateEdit={manualTCSRateEdit}
            />

        </Box>

        {/* Footer actions */}
        <Stack direction="row" spacing={1} justifyContent="flex-end" mt={2} flexWrap="wrap">

            <Button size="small" color="secondary" variant="outlined">Upload IRN Acknowledgement</Button>
            <Button size="small" color="secondary" variant="outlined" onClick={() => { handleSaveJsonFile() }}>Save Invoice As Json</Button>
        </Stack>

        {/* <Divider sx={{ borderStyle: "dashed", borderColor: "gray", borderWidth: "1px", marginTop:"20px" }} /> */}
    </ResponsiveBox>
);
};

InvoiceEntryTemplate.propTypes = {
    colors: PropTypes.any,
    theme: PropTypes.object,
    IParentInvoiceOrder_ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    SInvoiceNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedCustomer: PropTypes.object,
    dataCustomer: PropTypes.array,
    handleSelectCustomer: PropTypes.func,
    OrderDate: PropTypes.any,
    minInvoiceDate: PropTypes.any,
    handlerOrderDate: PropTypes.func,
    selectedSupplier: PropTypes.object,
    dataSupplier: PropTypes.array,
    handleSelectSupplier: PropTypes.func,
    SRefNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedTransporter: PropTypes.object,
    dataTransporter: PropTypes.array,
    handleSelectTransporter: PropTypes.func,
    ScheduleDate: PropTypes.any,
    handleScheduleDate: PropTypes.func,
    selectedPricelist: PropTypes.object,
    dataPricelist: PropTypes.array,
    handleSelectPricelist: PropTypes.func,
    Remarks: PropTypes.string,
    SetRemarks: PropTypes.func,
    visibleAmendmentReason: PropTypes.bool,
    SAmendmentReason: PropTypes.string,
    handleSelectAmendmentReason: PropTypes.func,
    amendmentReasonFoucs: PropTypes.bool,
    viewCancelDetail: PropTypes.bool,
    Reason: PropTypes.string,
    handleEnterReason: PropTypes.func,
    ReasonError: PropTypes.string,
    cancelDate: PropTypes.any,
    handleDateChange: PropTypes.func,
    DateError: PropTypes.string,
    rowsConfirmedOrdersDespacth: PropTypes.array,
    columnsConfirmedOrdersDespacth: PropTypes.array,
    rowModesModel: PropTypes.object,
    handleRowModesModelChange: PropTypes.func,
    handleRowEditStop: PropTypes.func,
    processRowUpdate: PropTypes.func,
    setrowsConfirmedOrdersDespacth: PropTypes.func,
    setRowModesModel: PropTypes.func,
    EditToolbar: PropTypes.any,
    totalSIConfirmedQty: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totalGrossAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totaldiscountAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totalAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    billToCustomerError: PropTypes.string,
    shipToCustomerError: PropTypes.string,
    transporterError: PropTypes.string,
    priceListError: PropTypes.string,
    selectedShipmentMode: PropTypes.object,
    handleSelectShipmentMode: PropTypes.func,
    dataShipmentmode: PropTypes.array,
    selectedPaymentTerm: PropTypes.object,
    handleSelectPaymentTerm: PropTypes.func,
    dataPaymentterm: PropTypes.array,
    selectedCreditTerm: PropTypes.object,
    handleSelectCreditTerm: PropTypes.func,
    dataCreditterm: PropTypes.array,
    selectedCreditTermRule: PropTypes.object,
    handleSelectCreditTermRule: PropTypes.func,
    dataCredittermRule: PropTypes.array,
    cancelReasonFoucs: PropTypes.bool,
};

export default memo(InvoiceEntryTemplate);



